import { Brick, registerBrick, Config } from "olympe";

export default class GenerateEmailBody extends Brick {
  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {string} groupName
   * @param {string} esAppUrl
   * @param {string} plannerAppUrl
   * @param {function()} forwardEvent
   * @param {function(string)} setContent
   */
  update($, [groupName, esAppUrl, plannerAppUrl], [forwardEvent, setContent]) {
    const contentHeader = "font-weight: bold; text-align: center;";
    const tdStyle = "padding: 0; width: 25%; text-align: center;"
    const envMap = {
      dev: "-codev",
      preprod: "-preprod",
      prod: "",
    };

    const environment = envMap[Config.getParameter("ENV")] || "";
    const imageHostLink = `https://ensuring-supply${environment}.olympe.io/esImages`;
    const riskAppImgLink = imageHostLink + "/ES-application.png";
    const plannerAppImgLink = imageHostLink + "/planner.png";
    // parent wrapper  div
    const emailWrapperDiv = document.createElement("div");
    emailWrapperDiv.setAttribute(
      "style",
      "font-family: Roboto, Helvetica Neue, Helvetica, Arial, sans-serif; max-width: 900px; display: grid;border: 1px solid #000000;"
    );

    // row-line div
    const rowBorderDiv = document.createElement("div");
    rowBorderDiv.setAttribute("style", "border-top: 1px solid #000000;");

    // header div
    const headerDiv = document.createElement("div");
    headerDiv.textContent = "Risk & Crisis Application";
    headerDiv.setAttribute(
      "style",
      "color: #FFFFFF; background-color: #F19100; text-align: center; font-weight: bold; padding: 3px;"
    );
    emailWrapperDiv.appendChild(headerDiv);
    //Cloning the row-line div to append at multiple position as appendChild() inserts the element at last postion only.
    emailWrapperDiv.appendChild(rowBorderDiv.cloneNode(true));

    //title div
    const titleDiv = document.createElement("div");
    titleDiv.textContent = `${groupName} has been created!`;
    titleDiv.setAttribute(
      "style",
      "text-align: center; font-weight: bold; font-size: 20px;  padding: 20px 0;"
    );
    emailWrapperDiv.appendChild(titleDiv);
    emailWrapperDiv.appendChild(rowBorderDiv.cloneNode(true));

    //sub-title div
    const subTitleDiv = document.createElement("div");
    subTitleDiv.textContent = "What can you do now in the Risk & Crisis app?";
    subTitleDiv.setAttribute(
      "style",
      "text-align: center; padding: 15px 0; font-size: 18px;"
    );
    emailWrapperDiv.appendChild(subTitleDiv);
    emailWrapperDiv.appendChild(rowBorderDiv.cloneNode(true));

    // parent table div
    const emailContentTable = document.createElement("table");
    emailContentTable.setAttribute("style", "width: 100%; border-spacing: 0;");

    const trElement = document.createElement("tr");

    // table-cell 1
    const tdElement1 = document.createElement("td");
    tdElement1.setAttribute("style", tdStyle);
    const riskAppImg = document.createElement("img");
    riskAppImg.src = riskAppImgLink;
    riskAppImg.width = "220";
    riskAppImg.height = "210";
    tdElement1.appendChild(riskAppImg);

    const riskAppLinkWrapper = document.createElement("span");
    riskAppLinkWrapper.setAttribute("style", "display: block; text-align: center;");

    const riskAppLink = document.createElement("a");
    riskAppLink.setAttribute("href", esAppUrl ? esAppUrl : "#");
    riskAppLink.innerText = "Risk & Crisis Application";
    riskAppLinkWrapper.appendChild(riskAppLink);
    tdElement1.appendChild(riskAppLinkWrapper);

     // table-cell 2
    const tdElement2 = document.createElement("td");
    tdElement2.setAttribute("style", tdStyle);
    const para1forTd2 = document.createElement("p");
    para1forTd2.textContent = "Collaborate with others";
    para1forTd2.setAttribute("style", contentHeader);

    const para2forTd2 = document.createElement("p");
    para2forTd2.setAttribute("style", "text-align: justify; padding: 0 8px;");
    para2forTd2.textContent =
      "Add members to your group to manage your risk/crisis. In the monitor tab, find your group using the search function & use the collaborators function to provide access.";
    tdElement2.appendChild(para1forTd2);
    tdElement2.appendChild(para2forTd2);

    //table-cell 3
    const tdElement3 = document.createElement("td");
    tdElement3.setAttribute("style", tdStyle);
    const plannerAppImg = document.createElement("img");
    plannerAppImg.src = plannerAppImgLink;
    plannerAppImg.width = "220";
    plannerAppImg.height = "210";
    tdElement3.appendChild(plannerAppImg);

    const plannerAppLink = document.createElement("a");
    plannerAppLink.setAttribute("href", plannerAppUrl ? plannerAppUrl : "#");
    plannerAppLink.innerText = "Planner Application";
    tdElement3.appendChild(plannerAppLink);

    // table-cell 4
    const tdElement4 = document.createElement("td");
    tdElement4.setAttribute("style", `${tdStyle} border-right: none;`);

    const para1forTd4 = document.createElement("p");
    para1forTd4.textContent = "Keep Progressing";
    para1forTd4.setAttribute("style", contentHeader);

    const para2forTd4 = document.createElement("p");
    para2forTd4.setAttribute("style", "text-align: justify; padding: 0 8px;");
    para2forTd4.textContent =
      "Assign tasks in the app or in Microsoft planner, do follow ups & track progress.";
    tdElement4.appendChild(para1forTd4);
    tdElement4.appendChild(para2forTd4);

    //append all table cells to table-row
    trElement.appendChild(tdElement1);
    trElement.appendChild(tdElement2);
    trElement.appendChild(tdElement3);
    trElement.appendChild(tdElement4);

    emailContentTable.appendChild(trElement);

    //append to parent wrapper div
    emailWrapperDiv.appendChild(emailContentTable);

    setContent(emailWrapperDiv.outerHTML);
    forwardEvent();
  }
}

registerBrick("018fb65fd8657b8c992b", GenerateEmailBody);
